import React, { useContext, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { AlertMessage } from '@/components/Profile/AlertMessage';
import { EditProfileContext } from '@/contexts/EditProfileProvider';
import {
  defaultProfilePageTitle,
  PROFILE_ROUTES,
  profilePageTitles,
} from '@/routers';

import Tabs from '../Tabs';

type ProfileLayoutProps = {
  isUserRole: boolean;
};

const ProfileLayout: React.FC<ProfileLayoutProps> = ({ isUserRole }) => {
  const { alertMessage } = useContext(EditProfileContext);
  const locationPath = useLocation();
  const location = locationPath?.pathname?.replace('/', '');
  const pageTitle = profilePageTitles[location] || defaultProfilePageTitle;

  const userRoleTabs = [
    {
      title: 'Membership',
      path: PROFILE_ROUTES.MEMBERSHIPS,
    },
  ];

  const tabs = [
    {
      title: 'Profile',
      path: PROFILE_ROUTES.PROFILE,
    },
    {
      title: 'Settings',
      path: PROFILE_ROUTES.NOTIFICATION,
    },
    ...(isUserRole ? userRoleTabs : []),
    {
      title: 'Billing',
      path: PROFILE_ROUTES.BILLING,
    },
  ];

  useEffect(() => {
    document.title = pageTitle;
  }, [locationPath]);

  return (
    <>
      {alertMessage && (
        <div className='alert-message max-w-1440px container mt-12'>
          <AlertMessage
            type={alertMessage.type}
            title={alertMessage.title}
            description={alertMessage.description}
          />
        </div>
      )}

      <div className='profile-tabs justify-center w-full flex flex-wrap mx-auto box-border'>
        <Tabs tabs={tabs} />
      </div>

      <Outlet />
    </>
  );
};

export default ProfileLayout;
